import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { SMSservice } from '../../../../core/services/sms.service';
import { HttpClient } from '@angular/common/http';
import { ProfileService } from '../../../../services/profile.service';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './profile-edit.component.html',
  styleUrl: './profile-edit.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class ProfileEditComponent {
  @Output() onClose = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Output() onRemove = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;

  profileImage: any;         // The actual profile image (real value)
  tempProfileImage: any;     // Temporary image for editing/cropping/capture
  patientInfo: any;
  fileName: string = '';
  fileExtnsion: string = '';
  elinkParams: any;
  elinkData: any;
  docId: string = '';
  fileType: string = '';
  base64Data: string = '';
  showCamera: boolean = false;
  isFrmOpenFile: boolean = false;
  currentCamera: 'user' | 'environment' = 'user';
  rotationAngle = 0;
  profileData: any;
  deleteData: any;
  changedProfile: boolean = false;
  errorMessage: string = '';
  isFrmChanged: boolean = false;
  canvasArea: any;
  bgImage: any;
  croppedImage: any;
  isFrmCropped: boolean = false;
  cropperStyle = {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
  };
  isFrmCapture: boolean = false;
  pharmacyInfo: any;

  @Input()
  set ProfileImage(pi: any) {
    this.profileImage = pi;
    this.tempProfileImage = pi; // Always start temp as original
  }

  @Input()
  set PatientProfileData(pd: any) {
    this.profileData = pd;
  }

  stream: MediaStream | null = null;
  imageChangedEvent: any;

  constructor(
    private smsService: SMSservice,
    private http: HttpClient,
    private _profileSvc: ProfileService
  ) {
    this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
    this.elinkData = localStorage.getItem("eLinkData") !== 'undefined' ? JSON.parse(localStorage.getItem("eLinkData") || '{}') : {};
  }

  ngOnInit() {
    console.log("profile-edit=>1",this.profileData.blobImageUrl);
      this.pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);

  }

  triggerFileUpload(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const maxSizeInMB = 5;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      const allowedExtensions = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedExtensions.includes(file.type)) {
        this.showError("Only JPEG, PNG, HEIC and JPG formats are allowed.");
      } else if (file.size > maxSizeInBytes) {
        this.showError("File size should not exceed 5 MB.");
      } else {
        const fileType = file.type.split('/')[1];
        this.fileType = '.' + fileType.toLowerCase();
        this.tempProfileImage=this.toBase64(file);
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.tempProfileImage = e.target.result; // Only temp!
          this.fileExtnsion = "." + (file.name.split('.').pop() || 'jpg');
          this.fileName = file.name.replace(/\s+/g, '_');
          this.rotationAngle = 0;
        };
        reader.readAsDataURL(file);
        this.isFrmOpenFile = true;
        this.changedProfile = false;
        this.imageChangedEvent = event;
        this.isFrmCapture = false;
      }
    }
  }

  imageCropped(event: any) {
    this.croppedImage = event.objectUrl;
    this.isFrmCropped = true;
    this.convertImageToBase64(this.croppedImage);
  }

  convertImageToBase64(url: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.tempProfileImage = reader.result as string;
        };
      },
      (error) => {
        console.error('Error fetching the image:', error);
      }
    );
  }

  imageLoaded(image: any) {
    this.cropperStyle.width = image.naturalWidth + 'px';
    this.cropperStyle.height = image.naturalHeight + 'px';
  }

  showError(message: string): void {
    this.errorMessage = message;
  }

  moveToPreviousPopup(frm?: string) {
    this.isFrmOpenFile = false;
    if (this.showCamera) {
      this.showCamera = false;
      this.stopCamera();
    }
    if (frm && frm === 'changed') {
      this.isFrmOpenFile = false;
      this.isFrmChanged = true;
      this.showCamera = false;
      this.changedProfile = false;
      // DON'T change profileData.blobImageUrl here!
    } else {
      this.isFrmChanged = false;
      this.changedProfile = false;
      this.isFrmOpenFile = false;
      // Reset temp to original in case of cancel
      this.tempProfileImage = this.profileImage;
    }
  }

  flipCamera() {
    this.stopCamera();
    this.currentCamera = this.currentCamera === 'user' ? 'environment' : 'user';
    this.openCamera(this.currentCamera);
  }

  openCamera(defaultCamera: 'user' | 'environment') {
    this.currentCamera = defaultCamera;
    this.showCamera = true;
    const constraints = {
      video: {
        facingMode: defaultCamera,
        width: { ideal: 1280 },
        height: { ideal: 720 },
      },
      audio: false,
    };
    navigator.mediaDevices.getUserMedia(constraints)
      .then((stream) => {
        const video = this.videoElement.nativeElement;
        video.srcObject = stream;
        video.play();
        this.stream = stream;
      })
      .catch((err) => {
        console.error('Error accessing the camera: ', err);
      });
  }

  captureImage(): void {
    const video = this.videoElement.nativeElement;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext('2d');
    if (context) {
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.tempProfileImage = canvas.toDataURL('image/png');
      this.fileType = this.getImageExtension(this.tempProfileImage);
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    }
    this.showCamera = false;
    this.isFrmOpenFile = true;
    this.isFrmCapture = true;
  }

  stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  rotateImage() {
    if (!this.tempProfileImage) return;
    const img = new Image();
    img.src = this.tempProfileImage;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (this.rotationAngle === 90 || this.rotationAngle === 270) {
        canvas.width = img.height;
        canvas.height = img.width;
      } else {
        canvas.width = img.width;
        canvas.height = img.height;
      }
      ctx?.translate(canvas.width / 2, canvas.height / 2);
      ctx?.rotate((this.rotationAngle * Math.PI) / 180);
      ctx?.drawImage(img, -img.width / 2, -img.height / 2);
      this.tempProfileImage = canvas.toDataURL();
      this.rotationAngle = (this.rotationAngle + 90) % 360;
      this.isFrmCapture = true;
    };
  }

  getImageExtension(dataUrl: string): string {
    const mimeType = dataUrl.substring("data:".length, dataUrl.indexOf(";base64"));
    const extension = mimeType.split("/")[1];
    return `.${extension}`;
  }
  toBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve((r.result as string).split(',')[1]);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
  async saveProfile() {
   const cleanBase64 = this.tempProfileImage.split(',')[1];
   const fullName = this.profileData?.patientInfo?.fullname;
   const docName = fullName ? `${fullName}_ProfilePicture` : `${this.fileName}_ProfilePicture`; 
    const payload = {
        Pharmacy: { IdentifierType: 0, Identifier:  this.elinkParams?.npi, Name: this.pharmacyInfo?.name },
        Application: { Id: 1, Name: "myPrimeRx" },
        Document: {
          Base64EncodedDoc: cleanBase64,
          Ext: this.fileExtnsion || this.getImageExtension(this.tempProfileImage),
          Name:  docName ,
          Type: "ProfilePicture",
          SubType: "Front"
        },
        SenderType: 0,
        RelatedEntity: { EntityType: 0,Name: fullName, Identifier: String(this.elinkData?.EntityId) },
        IncludeDocumentURLInResponse :true
      };
      try {
        const resp: any = await this.smsService.uploadImagesInChatHist(payload);
        if (resp){
          if (resp?.documentId) 
          {
            this.docId = resp.documentId;
            const profilePayload = {
      pharmacyNpi: this.elinkParams?.npi,
              patientId: this.elinkData?.EntityId,
              profilePictureId: this.docId,
            };
            console.log("profile-edit=>2",profilePayload);
            this.patientInfo = await this.smsService.saveProfilePictureId(profilePayload);
          }
          const uploadedUrl = resp?.url || resp?.documentURL || resp?.document?.documentURL;
        if (uploadedUrl)
        {
      this.profileImage = uploadedUrl; // <-- update only on save!
      this.profileData.blobImageUrl = this.profileImage;
      this.closePopup('save');
      this._profileSvc.setImage(this.profileData.blobImageUrl);
        }
        else{
      this.profileData.blobImageUrl = '';
      this.closePopup();
    }
    this.imageChangedEvent = null;
    this.isFrmCapture = false;
  
        } 
      } catch (e) {
        console.error('Upload failed for one file:', e);
      }

 }

  ngOnDestroy(): void {
    this.stopCamera();
  }

  async removeProfile() {
     const profilePayload = {
      pharmacyNpi: this.elinkParams?.npi,
              patientId: this.elinkData?.EntityId,
              profilePictureId: '',
            };
            console.log("profile-edit=>2",profilePayload);
            this.patientInfo = await this.smsService.saveProfilePictureId(profilePayload).then(data => {
              if (data) {
                this.profileImage = '';
                this.tempProfileImage = '';
                this.profileData.blobImageUrl = '';
                this._profileSvc.clearImage();
      }
      this.closePopup();
    })
  }

  setAvatarUrl() {
    const gender = this.profileData?.patientInfo?.gender;
    if (gender?.toLowerCase() === 'male') {
      this.profileImage = '/assets/images/male_pic.png';
    } else if (gender?.toLowerCase() === 'female') {
      this.profileImage = '/assets/images/female_pic.png';
    } else {
      this.profileImage = '/assets/images/dp_pic.png';
    }
    this.tempProfileImage = this.profileImage;
  }

  changeProfile() {
    this.changedProfile = true;
    this.isFrmOpenFile = false;
    this.showCamera = false;
    this.isFrmChanged = false;
    this.tempProfileImage = this.profileImage; // Always start with current real
  }

closePopup(isFrm?: string) {
    this.isFrmOpenFile = false;
    this.changedProfile = false;
    this.showCamera = false;
    this.isFrmChanged = false;

    // Emit original or new image as appropriate
    if (isFrm === 'save') {
        // On Save, emit the updated image
        this.onClose.emit(this.profileImage);
    } else {
        // On cancel/X, emit the original image (before editing)
        this.onClose.emit(this.profileImage);
        // Optionally reset tempProfileImage to original (optional)
        this.tempProfileImage = this.profileImage;
    }
}
}